import Vue from 'vue';
import Cookies from 'js-cookie';
import VueI18n from 'vue-i18n';
import messages from './langs';
Vue.use(VueI18n);

// 获取客户端的语言
function getLang () {
    let lang = '';
    if (Cookies.get('HY_LANGUAGE')) {
      lang = Cookies.get('HY_LANGUAGE');
    } else {
      lang = (navigator.language || navigator.browserLanguage).replace('-', '');
      // 将语言存入cookie
      if (lang !=='zhCN') {
        lang = 'en'
      } else {
        lang = 'zhCN'
      }
      Cookies.set('HY_LANGUAGE', lang);
    }
    return lang;
}
// 默认为中文
const i18n = new VueI18n({
    locale: getLang() || 'zhCN',
    fallbackLocale: 'zhCN',
    messages
});
// 解析路径
i18n.resolvePath = (link) => {
    if (i18n.locale !== 'zhCN') {
        let path = '/en' + link;
        return path.replace('/en/en/', '/en/');
    } else {
        return link.replace('/en/', '/');
    }
};
export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/i18n.js